var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", [
    _c(
      "ul",
      [
        _c("router-link", {
          attrs: { to: "/#concept" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("li", { class: [isExactActive && "active"] }, [
                    _c("a", { attrs: { href: href } }, [_vm._v("Concept")]),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("router-link", {
          attrs: { to: "/nos-scenarios-escape-caen" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("li", { class: [isExactActive && "active"] }, [
                    _c("a", { attrs: { href: href } }, [_vm._v("Nos énigmes")]),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("router-link", {
          attrs: { to: "/#nestor-bomb-simulator" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("li", { class: [isExactActive && "active"] }, [
                    _c("a", { attrs: { href: href } }, [_vm._v("NESTOR")]),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("router-link", {
          attrs: { to: "/#infos-pratiques" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("li", { class: [isExactActive && "active"] }, [
                    _c("a", { attrs: { href: href } }, [
                      _vm._v("Infos pratiques"),
                    ]),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("router-link", {
          attrs: { to: "/entreprises" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("li", { class: [isExactActive && "active"] }, [
                    _c("a", { attrs: { href: href } }, [_vm._v("Entreprises")]),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("router-link", {
          attrs: { to: "/nos-scenarios-escape-caen#bons-cadeaux" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("li", { class: [isExactActive && "active"] }, [
                    _c("a", { attrs: { href: href } }, [
                      _vm._v("Bons cadeaux"),
                    ]),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("router-link", {
          attrs: { to: "/contact#faq" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("li", { class: [isExactActive && "active"] }, [
                    _c("a", { attrs: { href: href } }, [_vm._v("f.a.q.")]),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("router-link", {
          attrs: { to: "/contact" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("li", { class: [isExactActive && "active"] }, [
                    _c("a", { attrs: { href: href } }, [_vm._v("Contact")]),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("router-link", {
          attrs: { to: "/#tarifs" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c("li", { class: [isExactActive && "active"] }, [
                    _c("a", { attrs: { href: href } }, [_vm._v("Tarifs")]),
                  ]),
                ]
              },
            },
          ]),
        }),
        _c("router-link", {
          attrs: { to: "/nos-scenarios-escape-caen" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c(
                    "li",
                    {
                      staticClass: "headerMenu_reserver",
                      class: [isExactActive && "active"],
                    },
                    [_c("a", { attrs: { href: href } }, [_vm._v("Réserver")])]
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }